module.exports = __webpack_public_path__ + "img/Voie_Terre_Vide.9214167a.png";